import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=7bf28cde"
import script from "./InputTextarea.vue?vue&type=script&lang=ts"
export * from "./InputTextarea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports